import MTag from './MTag.vue';

MTag.install = (app) => {
  app.component('MTag', MTag);
};

export { MTag };
